/**
 * TiTa 扩展路由（artist / activity / collaboration 等）
 * 非 EB 原厂 modules，集中在此注册；恢复 legacy 路由见 legacy.ts
 */
import type { RouteRecordRaw } from 'vue-router';
import artistRouter from '@/router/modules/expand/artist';
import activityRouter from '@/router/modules/expand/activity';
import collaborationRouter from '@/router/modules/expand/collaboration';
import performRouter from '@/router/modules/expand/perform';

const expandRouter: RouteRecordRaw[] = [
  artistRouter,
  activityRouter,
  ...collaborationRouter,
  performRouter,
];

export default expandRouter;
